<template>
  <div>
    <!-- pc -->
    <div class="d-pc-shop_search" v-if="!isH5">
      <el-popover
        :width="popoverWidth"
        placement="bottom-start"
        v-model="visible"
        trigger="focus"
        :visible-arrow="false"
        popper-class="d-pc-shop_search_popover"
      >
        <ListItem
          v-if="inputValue"
          :loading="loading"
          :words="words"
          @handleSelect="handleSelect"
          :input_word="inputValue"
          :isH5="isH5"
        ></ListItem>
        <div class="d-history-text" v-if="!inputValue" v-r-loading="loading">
          <div class="recommend-content">
            <div v-if="!noHistoryAndRecommendText">
              <HistoryText
                v-if="historySearchText"
                :historySearchText="historySearchText"
                @openDelHistoryDialog="openDelHistoryDialog"
                @handleSelect="handleSelect"
              ></HistoryText>
              <HotRecommend
                v-if="recommend"
                :recommend="recommend"
                @handleSelect="handleSelect"
              ></HotRecommend>
            </div>
            <!-- <div v-else-if="loading"></div>
            <NoList
            imgTop="30px"
              v-else-if="noHistoryAndRecommendText"
            ></NoList> -->
          </div>
        </div>
        <el-input
          slot="reference"
          :placeholder="$t('寻找餐厅和美食')"
          v-model="inputValue"
          input-on-composing
          clearable
          prefix-icon="icon-outline_search"
          class="reset-ipt-font-weight"
          @focus="focus"
          @blur="blur"
          ref="inputSearch"
          @keyup.enter.native="inputChange"
        >
        </el-input>
      </el-popover>
    </div>
    <!-- h5 -->
    <div v-else>
      <IndexH5
        :inputVal.sync="inputValue"
        :recommend="recommend"
        :historySearchText="historySearchText"
        :loading="loading"
        :words="words"
        :isH5="isH5"
        :noHistoryAndRecommendText="noHistoryAndRecommendText"
        @handleSelect="handleSelect"
        @openDelHistoryDialog="openDelHistoryDialog"
        @focus-event="focus"
        @inputChange="inputChange"
        @clear-words="clearWords"
        @get-search-suggestion="getSearchSuggestion"
      ></IndexH5>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {debounce} from 'lodash-es';
import {
  getLocalStorage,
  setLocalStorage,
  delLocalStorage,
} from '@/utils/localStorage';
import { post } from '@/lib/request/index';
import { feed } from '@/api/apiConstants';
import IndexH5 from './indexH5.vue';
import HistoryText from './historyText.vue';
import HotRecommend from './hotRecommend.vue';
import ListItem from './listItem.vue';
// import NoList from '../NoList';
export default {
  name: 'ShopSearch',
  components: {
    IndexH5,
    HistoryText,
    HotRecommend,
    ListItem,
    // NoList,
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      feed_rec_id: ({ feed }) => feed.recId,
    }),
    noHistoryAndRecommendText() {
      return !this?.historySearchText?.length && !this?.recommend?.length;
    },
    isFeedPage() {
      if (this.$route && this.$route.path === '/feed') {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      loading: false,
      inputValue: '',
      visible: false,
      popoverWidth: '',
      // 返回搜索热词
      recId: '',
      recommend: [],
      recommendShop: [],
      // 历史搜索词语
      historySearchText: [],
      historySearchTextMaxLength: 10,
      // 输入框输入词语的时候返回
      words: [],
      suggestionId: '',
      traceId: '',
      firstInputValue: false,
    };
  },
  watch: {
    $route:{
      handler(newV, oldV){
        const { q = '' } = newV?.query;
        if (q) {
          this.firstInputValue = true;
          this.inputValue = decodeURIComponent(decodeURIComponent(q));
        }else {
          this.inputValue = '';
        }
      },
      deep:true,
      immediate:true
    },
    inputValue(newV, oldV) {
      if (!newV) {
        this.suggestionId = '';
        this.loading = false
        return;
      }
      this.loading = true
      if (!this.firstInputValue) {
        if (!this.visible) this.visible = true;
      } else {
        this.firstInputValue = false;
      }
      this.getSearchSuggestion(newV);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.popoverWidth = this.$refs?.inputSearch?.$el?.offsetWidth;
    });
  },
  methods: {
    // 获取历史搜索热词
    async getSecommend() {
      this.loading = true;
      this.recommend = []
      try {
        const { recId, recommend, recommendShop } = await post(
          feed.FEED_RECOMMEND,
          {}
        );
        this.recId = recId;
        this.recommend = recommend.splice(0, this.historySearchTextMaxLength);
        this.recommendShop = recommendShop;
      } catch (err) {}
      this.loading = false;
    },
    // 获取历史搜索词语
    getHistorySearchText() {
      this.historySearchText = getLocalStorage('historySearchText') || [];
    },
    // 设置搜索历史词语
    setHistorySearchText(val) {
      if (!val) return;
      // 设置完之后，再获取，设置的最大数量
      // 获取当前的历史搜索词
      let currSearchText = getLocalStorage('historySearchText') || [];
      const searchIndex = currSearchText.indexOf(val);
      if (searchIndex > -1) {
        // 如果已经存在删除当前，
        currSearchText.splice(searchIndex, 1);
      }
      if (currSearchText.length >= this.historySearchTextMaxLength) {
        // 如果当前存储的值已经到了最大值，删除最后一个，
        currSearchText.pop();
      }
      // 将这个放在第一个位置
      currSearchText.unshift(val);
      setLocalStorage('historySearchText', currSearchText);
    },
    //  删除历史搜索词
    delHistorySearchText() {
      delLocalStorage('historySearchText');
      this.historySearchText = [];
    },
    // 删除历史搜索词语
    openDelHistoryDialog() {
      const _self = this;
      this.$rconfirm(_self.$t('确定要清除缓存吗？'), '', {
        confirmButtonText: _self.$t('确定'),
        cancelButtonText: _self.$t('取消'),
        customClass:'el-message-box_d-reset',
        showCancelButton: true,
        showClose: false,
        center: true,
        callback: action => {
          if (action === 'confirm') {
            this.delHistorySearchText();
          }
        },
      });
    },
    // 输入框变化的时候进行搜索
    getSearchSuggestion: debounce(async function() {
      if (!this.inputValue) return;
      this.$trackEvent({
        eventId: 'sailing_c_x_search_input_ck',
        eventLabel: '搜索词并输入',
        attrs: {
          input_word: this.inputValue,
        },
      });
      this.loading = true;
      try {
        const res = await post(feed.FEED_SEARCH_SUGGESTION, {
          param: {
            q: JSON.stringify({ tag: this.inputValue }),
            suggestionId: this.suggestionId,
          },
        });
        this.words = res?.words || [];
        this.suggestionId = res?.suggestionId || '';
        this.traceId = res?.traceId || '';
      } catch (err) {}

      this.loading = false;
    }, 500),
    clearWords() {
      this.loading = true;
      this.words = []
    },
    blur() {
      if (!this.isH5) {
        document.body.classList.remove('stop-scrolling');
      }
    },
    focus() {
      // 聚焦的时候，且有值得显示弹出层
      if (!this.isH5) {
        document.body.classList.add('stop-scrolling');
        this.popoverWidth = this.$refs?.inputSearch?.$el?.offsetWidth;
        this.visible = true;
      }
      if (!this.inputValue) {
        this.getHistorySearchText();
        this.getSecommend();
      }else {
        this.clearWords()
        this.getSearchSuggestion()
      }

      if (this.isFeedPage) {
        this.$trackEvent({
          eventId: 'sailing_c_x_search_textbox_ck',
          eventLabel: '首页搜索按钮点击',
        });
        this.$trackEvent({
          eventId: 'sailing_c_x_search_panel_sw',
          eventLabel: '首页搜索面板曝光',
          attrs: {
            poplular_recid: this.feed_rec_id,
          },
        });
      }
    },
    // 选中之后暴露给外面使用
    async handleSelect(search_word_source, q, ck_index) {
      if (search_word_source == 3) {
        this.$trackEvent({
          eventId: 'sailing_c_x_search_sugword_result_ck',
          eventLabel: '搜索联想词点击',
          attrs: {
            input_word: this.inputValue,
            sug_word: q,
            sug_rec_id: this.suggestionId,
            sug_trace_id: this.traceId,
            sug_index: ck_index,
          },
        });
      }
      this.setHistorySearchText(q);
      // 隐藏弹出层
      const objParams = {
        // 跳转到搜索页面
        path: '/search',
        query: {
          q, // url传参的时候编码
          search_word_source,
          sug_rec_id: this.suggestionId,
          sug_ck_json: JSON.stringify({
            input_word: this.inputValue,
            ck_word: q,
            ck_index,
            word_type: 0,
            id_date: 0,
          }),
        },
      }
      this.visible = false;

      if(this.$route?.name=='search') {
        this.$router.replace(objParams);
      }else {
        this.$router.push(objParams);
      }
    },
    // 回车的时候触发
    inputChange() {
      if (!this.inputValue) return;
      this.handleSelect(0, this.inputValue, 0); // search_word_source, q, ck_index
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
.d-pc-shop_search-content {
  
  padding-top: 4px;
  height: 280px;
  overflow-y: auto;
  margin: 8px 0;
  .shop-name {
    font-size: 14px;
    color: #000000;
    font-weight: 400;
  }
  .shop-name_box {
    margin-left: 16px;
    line-height: 18px;
    padding: 18px 61px 18px 0;
    border-bottom: 1px solid #e5e5e5;
    font-family: 'Aspira Light';
    font-size: 14px;
  }
  .shop-name:last-child {
    .shop-name_box {
      border-bottom: none;
    }
  }
  .shop-name:hover {
    background: #f5f5f7;
  }
}
.d-pc-shop_search {
  overflow-y: auto;
  height: 40px;
  span {
    display: flex;
  }
  // 搜索输入框样式重置
  .el-input {
    overflow: hidden;
    .el-input__prefix {
      font-size: 16px !important;
      left: 11.5px !important;
      z-index: 11;
      i {
        color: #666 !important;
      }
    }
    .el-input__suffix {
      font-size: 16px !important;
      right: 14px !important;
      border-color: none !important;
      .el-icon-circle-close:before {
        color: #ccc !important;
        content: '\EA05' !important;
        font-size: 16px !important;
        font-family: icon !important;
      }
    }
    .el-input__suffix:hover {
      .el-icon-circle-close:before {
        color: #999 !important;
      }
    }

    input {
      font-family: 'Aspira Light';
      border: none !important;
      background-color: #e3e3e6 !important;
      font-size: 14px !important;
      color: #000000 !important;
      font-weight: 400 !important;
      min-width: 257px !important;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px !important;
  }

  .el-input--suffix .el-input__inner {
    padding-right: 48px !important;
  }
  .el-input:hover {
    input {
      background-color: #f5f5f7 !important;
    }
  }
}
.d-history-text {
  height: 280px;
  padding: 0 16px;
  overflow: auto;
}
.d-pc-shop_search_popover {
  margin-top: 5.5px !important;
  border-radius: 4px;
  padding: 0;
  // height: 280px;
  overflow: hidden;
  border: none !important;
}
.reset-ipt-font-weight{
    input {
      font-family: 'Aspira Medium' !important;
      font-weight: 500 !important;
    }
  }
</style>
